<div class="searchable-dropdown">
    <input
        [disabled]="disabled()"
        type="text"
        id="paymentTerms"
        class="textField peer"
        autocomplete="off"
        [ngModel]="searchTerm()"
        (ngModelChange)="onInputChange($event)"
        (focus)="isListVisible.set(true)"
        placeholder=""
    />
    @if (isListVisible()) {
        <ul class="list">
            @for (option of filteredOptions(); track option.value) {
                <li
                    class="item"
                    [class.selected]="option.value === paymentTermValue()"
                    (click)="onOptionSelected(option.value)"
                >
                    {{ option.text }}
                </li>
            }
        </ul>
    }
    <label class="floating-lbl" for="paymentTerms">
        Payment Terms <span class="text-red-700">*</span>
    </label>
</div>